export const isSafeUrl = (url: string): boolean => /^https?:\/\//i.test(url);

/** Adds the protocol a bare host is missing, so `example.com` still opens. */
export const withHttpProtocol = (url: string): string =>
  isSafeUrl(url) ? url : `https://${url}`;

/**
 * The host a URL points at, for telling the user where a link is about to take
 * them. Falls back to the raw value when the URL cannot be parsed.
 */
export const getUrlHost = (url: string): string => {
  try {
    return new URL(withHttpProtocol(url)).host;
  } catch {
    return url;
  }
};
